<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("update password") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <form>
          <div class="field">
            <label class="label">{{ $t("new password") }}</label>
            <div class="control">
              <input class="input" type="password" v-model="meta.password" />
            </div>
          </div>
        </form>
        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <p class="buttons">
          <button
            class="button is-primary is-rounded"
            :disabled="is_form_invalid"
            @click="save"
          >
            <span class="icon">
              <i class="fa fa-save"></i>
            </span>
            <span>{{ $t("save") }}</span>
          </button>
          <button class="button is-rounded" @click="close_modal">
            {{ $t("cancel") }}
          </button>
        </p>
      </footer>
    </div>
  </div>
</template>
<script>
import { post, generate_error_message_text } from "@/utils";
import jssha1 from "js-sha1";

export default {
  name: "UpdatePasswordUserModal",
  // components: { GenericModal },
  data() {
    return {
      is_shown: false,
      meta: {},
      uuid: "",
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return !v.meta.password;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.is_shown = false;
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.is_shown = true;
      v.set_initial_state();
      v.uuid = uuid;
    },
    save() {
      let v = this;
      let obj = { password: jssha1(v.meta.password), uuid: v.uuid };
      post("/access/user/password", obj)
        .then(() => {
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      this.meta = {
        password: "",
      };
      this.uuid = "";
      this.error = "";
    },
  },
  mounted() {},
};
</script>
<style></style>
